export default [
    { key: 'code', label: 'ID', sortable: false },
    { key: 'name', label: 'Título' },
    { key: 'assignee.name', label: 'Responsable' },
    { key: 'description', label: 'Descripción' },
    { key: 'created_at', label: 'Fecha Creación' },
    { key: 'due_date', label: 'Fecha Vencimiento' },
    { key: 'resolution_date', label: 'Fecha Solución' },
    { key: 'notes', label: 'Notas', sortable: false },
    { key: 'files', label: 'Archivos', sortable: false },
    { key: 'actions', label: 'Acciones' },
]